import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import "./Profile.scss";
import "../dashboard/Dashboard.scss";
import { FiCamera } from "react-icons/fi";
import PlaylistCard from "../../components/Playlist/PlaylistCard";
import { fetchOtherProfile } from "../../store/profile/actions";
import { _fetchFollowing, _followUnfollow } from "../../store/follow/actions";
import { _addForChat } from "../../store/users/actions";

const OtherProfile = (props) => {
  const [state, setState] = useState({
    follow: false,
  });
  const { otherProfile, isOtherProfileLoading } = props.profile;

  useEffect(async () => {
    await props.fetchOtherProfile(props?.match?.params?.id);
    await props._fetchFollowing();
  }, []);

  useEffect(async () => {
    const followOrNot = await checkFollow();
    setState({
      follow: followOrNot,
    });
  }, [props.following.isFollowingLoaded]);

  const checkFollow = () => {
    if (props.following.isFollowingLoaded) {
      const checkFollow = props.following.following.filter(
        (follow) => follow?.followed?._id === otherProfile?._id
      );
      return checkFollow.length ? true : false;
    }
    return false;
  };

  const followUnfollow = async () => {
    await props._followUnfollow(otherProfile?._id);
    setState({
      follow: !state.follow,
    });
  };
  const letsMessage = async () => {
    await props._addForChat(otherProfile?._id);
    props.history.push('/chat');
  }

  return (
    <div className="Profile container ">
      <h1 className=" font-weight-bold text-black-50 mb-5 pb-3 border-bottom w-100 text-left">
        Profile Details
      </h1>
      {isOtherProfileLoading ? (
        "Loading..."
      ) : (
        <>
          <div className="card shadow ">
            <div className="row top h-100 ">
              <div className="col-12 d-flex justify-content-start "></div>
              <div className="col-12 col-md-6">
                <div className="pos-relative">
                  <img src="/images/bg/pp.png" alt="" className="top-img" />
                  <div className="camera">
                    <FiCamera className="text-white" />
                  </div>
                </div>
              </div>
              <div className="opt-btn-container">
                <div className="input-wrapper d-flex">
                  <button className="btn" onClick={() => followUnfollow()}>
                    {state.follow ? "Unfollow" : "Follow"}
                  </button>
                </div>
                <div className="input-wrapper d-flex">
                  <button className="btn" onClick={() => letsMessage()}>
                    Message
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="input-wrapper">
                  <div className="input-top">
                    <label htmlFor="" className="input-top-label">
                      Name
                    </label>
                  </div>
                  <input
                    type="text"
                    className="input form-control"
                    placeholder="e.g. John Doe"
                    required
                    name="name"
                    disabled
                    value={otherProfile.name}
                  />
                </div>
                <div className="input-wrapper">
                  <div className="input-top">
                    <label htmlFor="" className="input-top-label">
                      Email
                    </label>
                  </div>
                  <input
                    type="email"
                    className="input form-control"
                    placeholder="e.g. example@gmail.com"
                    required
                    name="email"
                    disabled
                    value={otherProfile.email}
                  />
                </div>
                <div className="input-wrapper">
                  <div className="input-top">
                    <label htmlFor="" className="input-top-label">
                      Music Gener
                    </label>
                  </div>
                  <input
                    type="text"
                    className="input form-control"
                    placeholder="e.g. Folk songs"
                    required
                    disabled
                    name="music_genre"
                    value={otherProfile.music_genre}
                  />
                </div>
                <div className="input-wrapper">
                  <div className="input-top">
                    <label htmlFor="" className="input-top-label">
                      Nickname
                    </label>
                  </div>
                  <input
                    type="text"
                    className="input form-control"
                    disabled
                    name="nick_name"
                    value={otherProfile.nick_name}
                  />
                </div>
                <div className="input-wrapper">
                  <div className="input-top">
                    <label htmlFor="" className="input-top-label">
                      Place of Birth
                    </label>
                  </div>
                  <input
                    type="text"
                    className="input form-control"
                    disabled
                    name="place_of_birth"
                    value={otherProfile.place_of_birth}
                  />
                </div>
                <div className="input-wrapper">
                  <div className="input-top">
                    <label htmlFor="" className="input-top-label">
                      Current Location
                    </label>
                  </div>
                  <input
                    type="text"
                    className="input form-control"
                    disabled
                    name="current_location"
                    value={otherProfile.current_location}
                  />
                </div>
                <div className="input-wrapper">
                  <div className="input-top">
                    <label htmlFor="" className="input-top-label">
                      Musical Instruments
                    </label>
                  </div>
                  <input
                    type="text"
                    className="input form-control"
                    disabled
                    name="musical_instruments"
                    value={otherProfile.musical_instruments}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="dashboard-inner">
            <div className="middle container ">
              <div className="d-flex justify-content-between my-3 border-bottom pb-3">
                <h1 className="h1 font-weight-bold text-black-50 ">
                  Courses offered by {otherProfile.name}
                </h1>
              </div>
              {otherProfile.playlists && (
                <div className="bg-white wrapper">
                  <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-4">
                    {otherProfile.playlists.map((item, i) => (
                      <PlaylistCard item={item} key={i} />
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  profile: state.profile,
  following: state.follow,
});

export default connect(mapStateToProps, {
  fetchOtherProfile,
  _fetchFollowing,
  _followUnfollow,
  _addForChat
})(OtherProfile);
